export const getGender = (gender: string) => {
    if (gender === 'Nam') return 'male'
    if (gender === 'Nữ') return 'female'
    return 'other'
}

export const getNationality = (nationality: string) => {
    if (nationality?.toLowerCase() === 'việt nam') return 'VN'
    return nationality
}

export const getReligion = (religion: string) => {
    if (religion === 'Không') return 'None'
    return religion
}
